import { connect } from "react-redux";

var ToggleMultiselect = require("components/utility/inputs/ToggleMultiselect");
var HelpSectionLink = require('components/utility/HelpSectionLink');
var CurrentUser = require("lib/account/CurrentUser");

var RosterSelectors = require("lib/selectors/RosterSelectors");
var RosterActions = require("lib/actions/RosterActions");


@connect(
	(state, props) => ({
		currentAdmin: RosterSelectors.admin({ state, id: CurrentUser.get().id }),
		studentLists: RosterSelectors.studentLists({ state }),
		readingLevelFormat: CurrentUser.get().prefs.reading_level_format,
		isLoadingStudents: RosterSelectors.isLoadingStudentLists({ state })
	}),
	(dispatch, props) => ({
		updateStudent: (update) => {
			return new Promise((resolve, reject) => {
				dispatch(RosterActions.updateStudent({ id: props.student.id, update })).then((response) => {
					resolve(response);
				}).catch(() => resolve({ error: true }));
			})
		},
		// updates student in state
		fetchStudent: (id) => {
			return dispatch(RosterActions.fetchStudent({ id, embeds: ["student.password"] }))
		}
	})
)
class RosterUnassignedStudent extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		this.state = this.getInitialState();
	}

	///////// HELPERS /////////
	getInitialState() {
		return {
			overrides: {},
			savingChanges: false
		}
	}

	prefs() {
		return this.props.student.prefs;
	}

	// returns current student
	formStudent() {
		return {
			...this.props.student,
			...this.state.overrides,
			prefs: {
				...this.prefs(),
				...this.state.overrides.prefs
			}
		};
	}

	isDemoStudent() {
		return this.props.student.demo_for_teacher
	}

	hasCleverUser() {
		return this.props.currentAdmin && this.props.currentAdmin.clever_user ? true : false
	}

	slOverrides() {
		var { student_list_ids } = this.state.overrides
		return student_list_ids
	}

	///////// STATE MANIPULATORS /////////

	// edits student information
	editStudentForm(key, val, callback) {
		this.setState({
			overrides: { ...this.state.overrides, [key]: val }
		}, callback)
	}

	///////// DATABASE MANIPULATORS /////////
	saveChanges(e) {
		$wr.nope(e);
		this.setState({ savingChanges: true })
		if (!_.isEmpty(this.state.overrides)) {
			this.props.updateStudent(this.state.overrides).then((response) => {
				var studentResponse = response.students[0];
				if (!studentResponse.errors) {
					window.wrNotifications.triggerDropDownNotification({
						title: "Student Edited!", text: "You have successfully edited a student!",
						icon: "ok-circle"
					})
					// update student data in state
					this.props.fetchStudent(studentResponse.id);
					if (this.props.onUpdateArchivedStudent) {
						this.props.onUpdateArchivedStudent()
					}
					// reset component state
					this.setState(this.getInitialState());
				} else {
					this.setState({ savingChanges: false })
					window.wrNotifications.triggerDropDownNotification({
						title: "Oops!", text: "Something went wrong and the student was not edited",
						type: "error", icon: "exclamation-sign"
					}, 4000);
				}
			});
		}
	}

	///////// RENDER METHODS /////////

	renderUpdateButton() {
		return this.slOverrides() ? <a className="btn btn-link saveButton" onClick={this.saveChanges.bind(this)}>Save</a> : ''
	}

	renderStudentListSelector() {
		if (this.hasCleverUser()) {
			var disableClass = "disableEvents"
			var topContent = (
				<div>
					A filled star is a primary class.<br />
					Empty stars are secondary classes.{" "}
					<HelpSectionLink featureName="Primary & Secondary Classes" linkSuffix="360054128371" iconOnly />
				</div>
			)
		} else {
			var topContent = (
				<div>
					Click a class to set it as primary.<br />
					Hold shift & click to set secondary.{" "}
					<HelpSectionLink featureName="Primary & Secondary Classes" linkSuffix="360054128371" iconOnly />
				</div>
			)
		}

		const toggles = [
			{
				key: "primary",
				icon: "star",
				select: ToggleMultiselect.SELECT_LEFT_CLICK,
				primary: true,
				singleton: true
			}, {
				key: "secondary",
				icon: "star-empty",
				select: ToggleMultiselect.SELECT_LEFT_SHIFT_CLICK,
			}
		]

		var options = this.props.studentLists.map(x => ({ key: x.id, text: x.name }));

		var selected = {}
		if (this.slOverrides()) {
			_.each(this.slOverrides().active, slID => {
				if (slID === this.slOverrides().primary) {
					selected[slID] = "primary";
				} else {
					selected[slID] = "secondary";
				}
			})
		}

		var onClassChange = (updatedSelected) => {
			var newStudentListIDs = {
				'active': [],
				'all': []
			}
			_.each(updatedSelected, (toggleKey, studentListID) => {
				newStudentListIDs.active.push(parseInt(studentListID));
				newStudentListIDs.all.push(parseInt(studentListID));

				if (toggleKey === "primary") {
					newStudentListIDs.primary = parseInt(studentListID);
				}
			})

			this.editStudentForm("student_list_ids", newStudentListIDs);
		}

		return (
			<ToggleMultiselect className={"classSelector unassignedSLToggle " + disableClass} dropdownDisplay="link"
				topContent={topContent}
				selected={selected}
				toggles={toggles}
				options={options}
				defaultDisplayText={'Select Student Lists'}
				onChange={onClassChange} />
		)
	}

	render() {
		var { student } = this.props;

		return (
			<div className="studentListMultiselect">
				<div className="topRow">
					<div className="studentInfo unassignedStudent">
						<div className="nameSection">
							{student.display_name}
						</div>
						{this.renderStudentListSelector()}
						{this.renderUpdateButton()}
					</div>
				</div>
			</div>
		);
	}
}

RosterUnassignedStudent.WrappedComponent.propTypes = PageStrictPropTypes({
	// From above
	student: PropTypes.object.isRequired,
	currentAdmin: PropTypes.object,
	selected: PropTypes.bool,
	toggleSelected: PropTypes.func,
	updateStudents: PropTypes.func,
	updateUnassignedStudents: PropTypes.func,
	onUpdateArchivedStudent: PropTypes.func,

	// @connect data
	populateData: PropTypes.func,
	studentLists: PropTypes.array,
	readingLevelFormat: PropTypes.string,
	isLoadingStudents: PropTypes.bool,
	studentList: PropTypes.object,

	// @connect handlers
	updateStudent: PropTypes.func,
	fetchStudent: PropTypes.func,
});

module.exports = RosterUnassignedStudent;


// WEBPACK FOOTER //
// ./modules/components/org/roster/RosterUnAssignedStudent.js